import { tv } from 'tailwind-variants';

export const container = tv({
  base: 'overflow-y-auto px-4 md:px-0 overflow-shadow',
  variants: {
    size: { [10]: 'max-h-[20rem]' },
  },
});
